interface ArticleEditToolbarProps {
  isSaving: boolean;
  onSave: () => void;
  onCancel: () => void;
}

export function ArticleEditToolbar({ isSaving, onSave, onCancel }: ArticleEditToolbarProps) {
  return (
    <div className="fixed bottom-6 right-8 flex gap-3 z-[1000]">
      <button
        onClick={onCancel}
        disabled={isSaving}
        className="px-5 py-3 bg-slate-500 hover:bg-slate-400 text-white border-none rounded-lg cursor-pointer text-sm font-semibold transition-opacity duration-200 disabled:opacity-60"
      >
        Cancel
      </button>
      <button
        onClick={onSave}
        disabled={isSaving}
        className="px-5 py-3 bg-emerald-500 hover:bg-emerald-400 text-white border-none rounded-lg cursor-pointer text-sm font-semibold transition-opacity duration-200 disabled:opacity-60"
      >
        {isSaving ? 'Saving...' : 'Save Changes'}
      </button>
    </div>
  );
}
